import React, { useContext, useEffect, useRef, useState } from 'react'
import StepFigure from 'app/React/Components/Main/StepFigure'
import { ProductShop } from 'app/ProductShop/ProductShop'
import AccessoryLink from 'app/React/Components/Form/AccessoryLink'
import { FeatureFlag } from 'utils/feature-flag'
import classNames from 'classnames'
import useWindowDimensions from 'react-components/Hooks/useWindowDimensions'
import FormStep4 from 'app/React/Components/Form/Step4/FormStep4'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Step4() {
  const {
    car,
    cartItems,
    currentVariant,
    isAccessoryShopOpen,
    order,
    strings,
    setCurrentStep,
    setIsAccessoryShopOpen,
  } = useContext(ConfiguratorContext)

  const steps = currentVariant.steps ?? {}

  if (steps['4'] === undefined) {
    setCurrentStep('5')
    return null
  }

  const settings = steps['4']?.settings ?? {}
  const hasNonPaymentTypeOptions = () => {
    for (let setting in settings) {
      const options = settings[setting].options

      for (let option in options) {
        if (options[option].hide_on !== order.paymentType && options[option].hide_on !== 'all') {
          return true
        }
      }
    }

    return false
  }

  const [accessoryLinkWidth, setAccessoryLinkWidth] = useState(0)
  const [isElementScrollable, setIsElementScrollable] = useState(false)
  const { width } = useWindowDimensions()

  const el = useRef()

  useEffect(() => {
    /** @type HTMLElement */
    const titleElement = el.current
    setAccessoryLinkWidth(titleElement?.getBoundingClientRect().width)
  }, [width])

  useEffect(() => {
    const el = document.querySelector('.step-4__wrapper .form')

    if (el) {
      if (el.scrollHeight > el.clientHeight) {
        setIsElementScrollable(true)
      } else {
        setIsElementScrollable(false)
      }
    }
  }, [])

  if (isAccessoryShopOpen || steps['4'].settings.length === 0 || !hasNonPaymentTypeOptions()) {
    return (
      <ProductShop
        specificModelId={car.id}
        specificVariantId={currentVariant.id}
        accessories={[]}
        categories_counts='0'
        models_counts='0'
        total='0'
        useAsModal
        whiteFilterBackground
        isLeasing={order.paymentType === 'leasing'}
        showType='configurator'
        context={ConfiguratorContext}
      />
    )
  }

  const accessoryCountIndicator = cartItems.length
  const carHasAccessory = () => {
    if (order.paymentType === 'cash' && currentVariant?.has_cash_accessories) {
      return true
    }

    if (order.paymentType === 'leasing' && currentVariant?.has_leasing_accessories) {
      return true
    }

    return false
  }

  function onElScroll() {
    const el = document.querySelector('.step-4__wrapper .form')

    if (el) {
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 1) {
        setIsElementScrollable(false)
      } else {
        setIsElementScrollable(true)
      }
    }
  }

  return (
    <div
      id='step-4'
      className={classNames('', { 'has-link': FeatureFlag.accessoryShop(), 'is-scrollable': isElementScrollable })}
    >
      <StepFigure step={steps['4'].step_id}/>
      <div className='step-4__wrapper'>
        <FormStep4 form={steps['4']} titleRef={el} onElScroll={onElScroll}>
          {FeatureFlag.accessoryShop() ? (
            <div className='accessory-shop-link' style={{ width: accessoryLinkWidth }}>
              {carHasAccessory() ? (
                <AccessoryLink
                  isAccessoryShopOpen={isAccessoryShopOpen}
                  setIsAccessoryShopOpen={setIsAccessoryShopOpen}
                  linkText={strings.form.accessory_shop.open}
                  accessoryCountIndicator={accessoryCountIndicator}
                />
              ) : null}
            </div>
          ) : null}
        </FormStep4>
      </div>
    </div>
  )
}
